import React from 'react';

import codeSplitComponentFactory from '../../../../common/codeSplitComponentFactory';
import BaseRouteHandler from '../../common/routeHandlers/BaseRouteHandler';

export const initialize = () => {
  const ManageAppsCodeSplit = codeSplitComponentFactory(() =>
    import(/* webpackChunkName: "chunk-manage-apps" */ './ManageAppsRoutesProcessor').then(
      (c) => c.default
    )
  );

  const RouteHandler = () => (
    <BaseRouteHandler includeSearch includeFooter={false}>
      <ManageAppsCodeSplit />
    </BaseRouteHandler>
  );

  return RouteHandler;
};

export default initialize();
